import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import less from 'less'
Vue.config.productionTip = false
import 'bootstrap'
import $ from 'jquery'
import '@/utils/rem'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import './common/font/font.css'
import '@/utils/element_use'
import '@/assets/css/iconfont.css'
import './utils/request'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
// 如果想加eslint 将此代码替换到package.json中
// "extends": [
//   "plugin:vue/essential",
//   "@vue/standard"
// ],
